/**
 * @author       yontaek@zumper.com (Yon Taek Chung)
 * @copyright    Copyright (c) 2020, Zumper
 * @description  Tour availability bizo
 */

import { Bizo, autoclass } from './base'
import type {
  PropertyTourIntegration as PropertyTourIntegrationType,
  RawPropertyTourIntegration,
  RawTourAvailability,
  RawTourIntegration,
  TourAvailability as TourAvailabilityType,
  TourIntegration as TourIntegrationType,
  TourIntegrationEmpty,
  TourIntegrationNonEmpty,
} from './tourAvailability.types'

export const TourAvailability: typeof TourAvailabilityType = autoclass<
  TourAvailabilityType,
  RawTourAvailability
>(
  'TourAvailability',
  class TourAvailability extends Bizo<TourAvailabilityType, RawTourAvailability> {},
  {
    availableTimes: 'available_times',
    type: 'type',
  }
)

export type TourAvailability = TourAvailabilityType

export const PropertyTourIntegration: typeof PropertyTourIntegrationType = autoclass<
  PropertyTourIntegrationType,
  RawPropertyTourIntegration
>(
  'PropertyTourIntegration',
  class PropertyTourIntegration extends Bizo<
    PropertyTourIntegrationType,
    RawPropertyTourIntegration
  > {},
  {
    createdOn: 'created_on',
    groupId: 'group_id',
    modifiedOn: 'modified_on',
    propertyTourIntegrationId: 'property_tour_integration_id',
    provider: 'provider',
    providerEnabled: 'provider_enabled',
    providerId: 'provider_id',
    tourTypes: 'tour_types',
    zumperEnabled: 'zumper_enabled',
  }
)

export type PropertyTourIntegration = PropertyTourIntegrationType

export const TourIntegration = autoclass<TourIntegrationType, RawTourIntegration>(
  'TourIntegration',
  class TourIntegration extends Bizo<TourIntegrationType, RawTourIntegration> {},
  {
    availability: { name: 'availability', type: TourAvailability },
    integration: { name: 'integration', type: PropertyTourIntegration },
  }
) as unknown as typeof TourIntegrationEmpty & typeof TourIntegrationNonEmpty

export type TourIntegration = TourIntegrationType
